import { styled } from "@mui/material";

import { Dialog as UnstyledDialog } from "#src/components/form";

export const Dialog = styled(UnstyledDialog)(({ theme }) => ({
  "&.MuiDialog-container": {
    backdropFilter: `blur(${theme.spacing(1)})`,
  },
}));
